import { IRequestParams, IResultContent, request } from "@fanfanlo";
import { tms } from "../tms";
import { IRequestOptions } from "../IRequestOptions";

/**
 * @description 响应紧急联系人邀请的请求参数
 */
export interface IEmcRespondToInviteParams extends IRequestParams {
    invitation_id: string;
    action: 'accept' | 'decline';
}

/**
 * @description 响应邀请的完整响应体
 */
export interface IEmcRespondToInviteResult extends IResultContent {
    // No special data is expected in the result for this call
}

/**
 * @description 调用响应邀请接口的函数
 * @param opts 包含 params, gateway, handler 的请求选项
 */
export async function tmsEmcRespondToInvite(opts: IRequestOptions<IEmcRespondToInviteParams>) {
    const res = await request<IEmcRespondToInviteResult>(tms.TEmc, tms.MEmcRespondToInvite, opts.params, opts.gateway, opts.handler);
    return res;
}
